import React from "react";
import Typography from "@common/components/Typography";
import {
  ElogRoom,
  ElogDevice,
  MeetingInstance,
  ElogParticipant,
} from "@services/meetings/types";
import { Room } from "@services/rooms/types";
import { Device } from "@services/devices/types";
export type ContentProps = {
  participant: Partial<ElogParticipant>;
  onChange: React.Dispatch<React.SetStateAction<Partial<ElogParticipant>>>;
  emptyDialOption?: boolean;
};

export const fromRoom = (r: Room): ElogRoom => ({ ...r, summary: null });
export const fromDevice = (d: Device, r: Room): ElogDevice => ({
  ...d,
  room: fromRoom(r),
});

export type RoomOptions = { room: Room; devices: Device[] }[] & {
  externals?: MeetingInstance["participants"];
};
export const prepareRoomOptions = (
  participants: MeetingInstance["participants"]
): RoomOptions => {
  const rooms: RoomOptions = [];
  (participants ?? []).forEach((participant) => {
    const found = rooms.find(({ room }) => participant.room?.id === room.id);
    if (found) {
      if (participant.device) found.devices.push(participant.device);
    } else {
      if (participant.room && participant.device)
        rooms.push({ room: participant.room, devices: [participant.device] });
    }
  });
  rooms.externals = participants?.filter(
    (p) => !p.device && !p.room && p.scheduled
  );
  return rooms;
};

export const emptyOption = { label: <Typography reserveSpace />, value: "" };

export const NON_EMPTY_VALUE =
  "Just need a non-empty to trick the select into showing 'other'";
